import { replaceChildrenWithClones } from "../../../helpers/replaceChildrenWithClones";

export default [
    {
        key: "stol__ps_kp",
        extra: (el) => {
            replaceChildrenWithClones(el); // TODO КОСТЫЛЬ
        },
    },
    {
        key: "elektropanel",
        allArray: "allElektropanelSP",
        activeArray: "activeElektropanelSP",
        position: "top",
    },
    {
        key: "tumba",
        allArray: "allTumbaSP",
        activeArray: "activeTumbaSP",
        position: "bottom",
    },
];
